import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStylesForOCP, ColumnValues } from '../../../Components/helper';
import { commonPath, colourArrayPath } from './fieldPath';

export default function ColourComponent({ columnEle, columnIndex, handleChange }) {
  const { t } = useTranslation('common');
  return (
    <Accordion>
      <Card className="color-card">
        <Card.Header className="color-card-header ">
          <div className="d-flex  align-items-center reducing-switch-z-index">
            <div className="custom-control d-inline-flex design-switch mt-0 ">
              <input
                type="checkbox"
                className="form-check-input"
                id={`colourSwitch_${columnIndex}`}
                name="colourSwitch"
                onChange={(e) => handleChange(e?.target?.checked, commonPath(columnIndex, 'colorSwitch').COMMON, columnIndex, [])}
                checked={columnEle?.colorSwitch}
              />
              <label style={{ marginTop: 4 }} className="text-nowrap f-16 font-heavy ml-8 mb-0" htmlFor={`colourSwitch_${columnIndex}`}>
                {t('PIM_MODULE.COLUMN_MODAL.COLOUR_COMPONENT.COLOUR_CODING')}
              </label>
            </div>
          </div>
          <div style={{ marginTop: 5 }} className="ml-auto">
            <i className="icon-new-down-arrow-icon  f-20" />
          </div>
        </Card.Header>
        {columnEle?.colorSwitch && (
          <Card.Body className="pb-0">
            <div className="flex-fill">
              {columnEle?.colourArray?.map((element, index) => {
                return (
                  <div className="d-flex align-items-center f-16 mb-16" key={`${element?.colourType}`}>
                    <div className="status-color-container d-flex">
                      <span className={`${element?.colourType} round-shape`} />
                    </div>
                    <div className="d-flex flex-fill align-items-center">
                      <span className="ml-16 font-heavy text-nowrap">{'if '}</span>
                      <div className="common-react-select flex-fill ml-16 mb-0">
                        <Select
                          name="colourValue"
                          options={ColumnValues?.filter((ele) => !columnEle?.colourArray?.map((e) => e?.colourValue?._id)?.includes(ele?._id))}
                          getOptionLabel={(option) => `${option?.name}`}
                          getOptionValue={(option) => `${option?._id}`}
                          menuPlacement="bottom"
                          menuPosition="fixed"
                          isClearable
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                          value={element?.colourValue || null}
                          styles={customStylesForOCP}
                          className="common-select"
                          classNamePrefix="common-select"
                          onChange={(e) => handleChange(e, colourArrayPath(columnIndex, index, 'colourValue')?.COLOUR_ARRAY_CHANGE, columnIndex, [])}
                          placeholder={t('PIM_MODULE.COLUMN_MODAL.COLOUR_COMPONENT.SELECT_VALUE')}
                        />
                      </div>
                      <input
                        className="form-control text-bordered decimal-input ml-16"
                        onChange={(e) =>
                          handleChange(e?.target?.value, colourArrayPath(columnIndex, index, 'startPercentage').COLOUR_ARRAY_CHANGE, columnIndex, [])
                        }
                        disabled={!element?.colourValue}
                        value={element?.startPercentage}
                        type="number"
                        name="colourStateValue"
                      />{' '}
                      {columnEle?.columnType?.key === 'Number_percentage' ? <span className="color-percent">%</span> : ''}
                      {element?.colourValue?._id === 'between' && (
                        <div className="d-flex common-input-control mb-0 align-items-center ml-16">
                          and
                          <input
                            className="form-control text-bordered decimal-input ml-16"
                            onChange={(e) =>
                              handleChange(e?.target?.value, colourArrayPath(columnIndex, index, 'endPercentage')?.COLOUR_ARRAY_CHANGE, columnIndex, [])
                            }
                            disabled={!element?.colourValue}
                            value={element?.endPercentage}
                            name="colourStateValue"
                            type="number"
                          />{' '}
                          {columnEle?.columnType?.key === 'Number_percentage' ? <span className="color-percent">%</span> : ''}
                        </div>
                      )}
                      {columnEle?.hasError && element?.colourValue && (!element?.startPercentage || !element?.endPercentage) && (
                        <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.COLOUR_COMPONENT.ERROR_MESSAGE')}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Card.Body>
        )}
      </Card>
    </Accordion>
  );
}
